import { TradeSubType, TradingInstructionDirection, Currency } from "swan-public-api-client";
import { IntlShape } from "react-intl";
import { OpeningOrClosing } from "../TradeHistory/TradeHistoryGridRow";

export function tradeSubTypeToStringConverter(value: TradeSubType, intl: IntlShape) {
  switch (value) {
    case TradeSubType.New:
      return intl.formatMessage({ id: "tradeSubType.new" });
    case TradeSubType.Roll:
      return intl.formatMessage({ id: "tradeSubType.roll" });
    case TradeSubType.FxConversionOpen:
      return intl.formatMessage({ id: "tradeSubType.fxConversionOpen" });
    default:
      return intl.formatMessage({ id: "converters.unknownValue" });
  }
}

export function tradingInstructionDirectionToStringConverter(value: TradingInstructionDirection, intl: IntlShape) {
  switch (value) {
    case TradingInstructionDirection.Buy:
      return intl.formatMessage({ id: "tradingInstructionDirection.buy" });
    case TradingInstructionDirection.Sell:
      return intl.formatMessage({ id: "tradingInstructionDirection.sell" });
    default:
      return intl.formatMessage({ id: "converters.unknownValue"});
  }
}

export function quantityDirectionToStringConverter(value: number, intl: IntlShape) {
  return tradingInstructionDirectionToStringConverter(
    value >= 0
      ? TradingInstructionDirection.Buy
      : TradingInstructionDirection.Sell,
    intl);
}

export function openingOrClosingToStringConverter(value: OpeningOrClosing, intl: IntlShape) {
  switch (value) {
    case OpeningOrClosing.opening:
      return intl.formatMessage({ id: "openingOrClosing.opening" });
    case OpeningOrClosing.closing:
      return intl.formatMessage({ id: "openingOrClosing.closing" });
    default:
      return intl.formatMessage({ id: "converters.unknownValue"});
  }
}

export function currencyToStringConverter(value: Currency | undefined, intl: IntlShape) {
  return value?.IsoCode ?? intl.formatMessage({ id: "converters.unknownValue"});
}
